import ProjectVariation from "../types/ProjectVariation";
import ProjectVariationLink from "../types/ProjectVariationLink";
import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postProjectVariationLink = (
    token: string,
    backend: string,
    body: ProjectVariationLink
) => {
    return fetch(
        `${getApiUrl(backend)}project_variation_links`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        }
    );
};

export default postProjectVariationLink;
